module.exports = __webpack_public_path__ + "static/media/keep-safe-tip03.8a982421.png";